import BootstrapButton from "react-bootstrap/Button";

const Button = ({...otherProps}) => {
  return <BootstrapButton {...otherProps}/>;
};

export default Button;
